import { Alert, showError } from '@calendly/alert';
import { I18n } from '@calendly/i18n';
import { Logger } from '@calendly/logging-service';
import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { redirectToAuthorizeUrl } from 'actions/omniauth';
import { PageContent } from 'components/page_elements';
const containerCss = "c10idk3";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const ALLOWED_REDIRECT_PATH = ['oktaoauth', 'azure_oauth2', 'azure2_oauth2'];
export const OauthPostRedirect = () => {
  const dispatch = useDispatch();
  const {
    redirectPath
  } = useParams();
  useEffect(() => {
    if (!ALLOWED_REDIRECT_PATH.includes(redirectPath)) {
      Logger.info(`'${redirectPath}' is not one of the allowed values ${ALLOWED_REDIRECT_PATH}`);
      dispatch(showError(I18n.t('errors.default')));
    } else {
      const path = `/users/auth/${encodeURIComponent(redirectPath)}`;
      const query = window.location.search;
      dispatch(redirectToAuthorizeUrl(`${path}${query}`));
    }
  }, [dispatch, redirectPath]);
  return <PageContent>
      <Container>
        <Alert />
        <Loader aria-label="Redirecting..." />
      </Container>
    </PageContent>;
};

require("./oauth_post_redirect.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./oauth_post_redirect.js");